import { WeaTools } from 'ecCom'

export const getTabInfo = (params) => {
    return WeaTools.callApi('/api/hrm/report/constrpsubsearch/getTabInfo', 'POST', params);
}

export const getCondition = (params) => {
    return WeaTools.callApi('/api/hrm/report/constrpsubsearch/getCondition', 'POST', params);
}

export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/report/constrpsubsearch/getSearchList', 'POST', params);
}

export const saveTemplete = (params) => {
    return WeaTools.callApi('/api/hrm/report/constrpsubsearch/saveTemplete', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/constrpsubsearch.js